import { Box, Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

export default function Support() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box sx={{ flexGrow: 0 }}>
                <Button
                    // href='https://audiolo.atlassian.net/servicedesk/customer/portal/1'
                    // target='_blank'
                    onClick={handleClick}
                    sx={(theme) => ({ color: theme.palette.primary.contrastText })}
                >
                    Support
                </Button>
            </Box>
            <Menu
                id='support-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'support-menu',
                }}
            >
                <MenuItem
                    component='a'
                    href='https://audiolo.com/resources'
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    Tutorials
                </MenuItem>
                <MenuItem
                    component='a'
                    href='https://audiolo.atlassian.net/servicedesk/customer/portal/1'
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    Support
                </MenuItem>
            </Menu>
        </>
    );
}